"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockchainBaseURL = exports.getCurrencyExplorer = exports.findCurrencyExplorer = void 0;
const invariant_1 = __importDefault(require("invariant"));
const live_env_1 = require("@ledgerhq/live-env");
const findCurrencyExplorer = (currency) => {
    var _a;
    if ((0, live_env_1.getEnv)("SATSTACK") && currency.id === "bitcoin") {
        return {
            endpoint: (0, live_env_1.getEnv)("EXPLORER_SATSTACK"),
            id: "btc",
            version: "v3",
        };
    }
    if (currency.explorerId == null) {
        console.warn("no explorerId for", currency.id);
    }
    return {
        endpoint: (0, live_env_1.getEnv)("EXPLORER"),
        id: (_a = currency.explorerId) !== null && _a !== void 0 ? _a : currency.id,
        version: "v4",
    };
};
exports.findCurrencyExplorer = findCurrencyExplorer;
const getCurrencyExplorer = (currency) => {
    const res = (0, exports.findCurrencyExplorer)(currency);
    (0, invariant_1.default)(res, `no Ledger explorer for ${currency.id}`);
    return res;
};
exports.getCurrencyExplorer = getCurrencyExplorer;
const blockchainBaseURL = (currency) => {
    const { id, version, endpoint } = (0, exports.getCurrencyExplorer)(currency);
    return `${endpoint}/blockchain/${version}/${id}`;
};
exports.blockchainBaseURL = blockchainBaseURL;
//# sourceMappingURL=explorer.js.map